import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import UserRepository from "../../Repository/UserRepository";
import { Box, Button, Stack, styled } from "@mui/material";
import profileImg from "../../images/profile.png";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import { toast } from "react-toastify";
import DeleteDialog from "../reusableComponents/DeleteDialog";
import DialogComponent from "../reusableComponents/Dialog";
import EmpDetails from "./EmpDetails";
import AddUser from "./AddUser";

const RootStyle = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexWrap: "wrap",
});

const ItemBox = styled("div")({
  backgroundColor: "white",
  minHeight: "200px",
  boxShadow: "0px 1px 2px rgb(161, 161, 161)",
  padding: "10px",
  borderRadius: "5px",
  margin: "5px 10px",
});
const IconBox = styled("div")({
  color: "red",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "5px",
  background: "#fff",
  boxShadow: "0px 4px 16px rgb(0 0 0 / 16%)",
  borderRadius: "4px",
  cursor: "pointer !important",
  margin: "0px 10px",
});

function EmployeesList({ employees, onSuccess, loading }) {
  const [modal, setModal] = useState(false);
  const [state, setState] = useState({
    deleteModal: false,
    detailModal: false,
    employeeDetail: "",
    selectedEmp: "",
  });

  const addToggle = () => {
    setModal((prev) => !prev);
  };
  const toggle = (name) => {
    setState((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const handleDelete = (id) => {
    setState((prev) => ({ ...prev, selectedEmp: id, deleteModal: true }));
  };

  const deleteEmployee = async (id) => {
    toggle();
    let { data } = await UserRepository.usersModel({
      request: {
        method: "deleteUser",
        data: {
          _id: state.selectedEmp,
        },
      },
    });
    onSuccess();
    toast.configure();
    toast.info("User removed successfully");
  };

  const handleDetail = (data) => {
    setState((prev) => ({ ...prev, employeeDetail: data, detailModal: true }));
  };

  const handleSuccess = () => {
    addToggle();
    onSuccess();
  };

  return (
    <Box>
      {!loading && (
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            sx={{ color: "#4EAF51", fontSize: { md: "2rem", xs: "16px" } }}
          >
            My Employees
          </Typography>
          <Button
            variant="contained"
            size="small"
            sx={{ textTransform: "none" }}
            onClick={addToggle}
          >
            Add Employee
          </Button>
        </Box>
      )}
      <RootStyle>
        {employees &&
          employees.map((employee, i) => {
            return (
              <Stack key={i} marginTop="20px">
                <ItemBox>
                  <img
                    width="150px"
                    height="170px"
                    src={employee.base_url ? employee.base_url : profileImg}
                    onClick={() => handleDetail(employee)}
                    alt=""
                  />
                  <Typography variant="h6" sx={{ textAlign: "center" }}>
                    {employee.username}
                  </Typography>
                </ItemBox>
                <IconBox onClick={() => handleDelete(employee._id)}>
                  <DeleteTwoToneIcon />
                </IconBox>
              </Stack>
            );
          })}
      </RootStyle>

      <DeleteDialog
        title="Delete Employee"
        open={state.deleteModal}
        onClose={() => toggle("deleteModal")}
        onClickYes={deleteEmployee}
      />
      <DialogComponent
        title="Employee"
        open={state.detailModal}
        onClose={() => toggle("detailModal")}
        dialogContent={
          <EmpDetails
            user={state.employeeDetail}
            onSuccess={onSuccess}
            onClose={() => toggle("detailModal")}
          />
        }
      />
      {modal && <AddUser onClose={addToggle} onSuccess={handleSuccess} />}
    </Box>
  );
}

export default EmployeesList;
